import { HeroIcon } from '@components/HeroIcon'
import { Text, useMedia, View, XStack } from 'tamagui'
import { Progress } from '@components/Progress'

interface IMobileExtendedCardContentProps {
  title: string
  productName: string
  dataProgress?: {
    progress: number
    completedLessons: number
    totalLessons: number
  } | null
}

export function MobileExtendedCardContent({
  title,
  productName,
  dataProgress,
}: IMobileExtendedCardContentProps) {
  const media = useMedia()
  const titleNumberOfLines = media.gtSm ? 3 : 2
  const isCompleted = dataProgress?.progress === 100
  const titleFontSize = media.gtSm ? '$font-size-xxs' : '$font-size-xxs'
  const getProgressIndicatorColor = isCompleted ? '$success-300' : '$info-300'
  const getProgress =
    dataProgress && dataProgress.progress ? dataProgress.progress : 0
  const isStarted = (dataProgress?.progress ?? 0) > 0
  const displayProgress = dataProgress && dataProgress.totalLessons !== null

  return (
    <View
      backgroundColor="$neutral-0"
      width="50%"
      $gtSm={{
        width: '60%',
      }}
      justifyContent="space-between"
    >
      <View gap="$size.spacing-xxxs">
        <Text
          ff="$mulishSemiBold"
          color="$neutral-800"
          fontSize={titleFontSize}
          fontWeight="600"
          numberOfLines={titleNumberOfLines}
        >
          {title}
        </Text>
        <Text
          ff="$mulishSemiBold"
          color="$neutral-500"
          fontSize="$font-size-xxxs"
          display="flex"
          gap={8}
          numberOfLines={2}
        >
          {productName}
        </Text>
        {displayProgress && (
          <XStack alignItems="center" gap="$spacing-inset-xxs">
            <Progress
              value={getProgress}
              height={6}
              foregroundColor={getProgressIndicatorColor}
            />
            <XStack gap={6}>
              {isCompleted ? (
                <HeroIcon
                  icon={['fal', 'check-circle']}
                  color="$success-300"
                  size={media.gtSm ? 16 : 14}
                />
              ) : (
                <>
                  {isStarted && (
                    <Text
                      color="$success-300"
                      ff="$mulishRegular"
                      fontWeight={400}
                      fontSize="$font-size-xxxs"
                    >
                      {dataProgress?.completedLessons}
                    </Text>
                  )}
                  <Text
                    color="$cross-white"
                    ff="$mulishRegular"
                    fontWeight={400}
                    fontSize="$font-size-xxxs"
                  >
                    {isStarted ? 'de' : ''} {dataProgress?.totalLessons}
                  </Text>
                </>
              )}
            </XStack>
          </XStack>
        )}
      </View>
    </View>
  )
}
